import { DomSanitizer } from "@angular/platform-browser";
import { Block } from "./model/block.model";

export function getLondon(sanitizer: DomSanitizer): Block[] {
    return [
        {
            backImg: null,
            backImgName: null,
            blockImg: "/assets/img/blog/倫敦空汙治理/eDM banner top.jpg",
            blockImgName: "",
            blockIndex: 0,
            blockName: "block1",
            blockType: 8,
            content: null,
            id: 1,
            imgLink: null,
            imgPosition: null,
            subtitle: null,
            title: null,
            imgInfo: sanitizer.bypassSecurityTrustHtml(
                '<span style="font-size: 16px"></span>'
            ),
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: null,
            blockImgName: null,
            blockIndex: 8,
            blockName: "block9",
            blockType: 3,
            content: null,
            id: 5,
            imgLink: null,
            imgPosition: null,
            subtitle: sanitizer.bypassSecurityTrustHtml(
                '<span style="font-size: 12px; color: gray; float: left;text-transform:lowercase;;font-weight: normal">(圖1) adobe stock</span>'
            ),
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: null,
            blockImgName: null,
            blockIndex: 8,
            blockName: "block9",
            blockType: 3,
            content: null,
            id: 5,
            imgLink: null,
            imgPosition: null,
            subtitle: sanitizer.bypassSecurityTrustHtml(
                '<p style="font-size: 20px; text-align: left; color: black; margin-top: 70px">「當我第一次擔任市長時，科學家說，要讓倫敦的空氣達到安全標準，得等上 193 年。」倫敦市長薩迪克·汗，在 2025 年 3 月的記者會上這麼說。<br/>如今，只花了 8 年，倫敦就往這個曾被視為「不可能」的目標大幅邁進。<br/>不是因為科技突破，也不是市民集體棄車，而是一項曾引發抗議與政治風暴的制度「超低排放區（ULEZ-Ultra Low Emission Zone）政策」。<br/>這場城市治理實驗告訴我們：好的制度設計，能把永續從願景變成現實。</p>'
            ),
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: null,
            blockImgName: null,
            blockIndex: 8,
            blockName: "block9",
            blockType: 3,
            content: null,
            id: 5,
            imgLink: null,
            imgPosition: null,
            subtitle: sanitizer.bypassSecurityTrustHtml(
                '<p style="font-size: 20px; text-align: left; color: black; margin-top: 20px"><b>環境政策不是口號，而是可以真實改變一整個城市生活品質的工程。」</b><br/>也讓我們思考在城市治理與永續轉型的道路上，<b>有沒有一種制度與合作方式，可以讓更多城市也做到這件事？</b></p>'
            ),
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: "/assets/img/blog/倫敦空汙治理/2.jpeg",
            blockImgName: "NCour_NTUST_4.jpg",
            blockIndex: 4,
            blockName: "block5",
            blockType: 6,
            content: sanitizer.bypassSecurityTrustHtml(
                '<p style="color: #2681bd; font-size: 22px">呼吸-守護城市的空間</p>' +
                    '<p style="font-size: 20px; color: black;">當世界多數城市仍在和碳排折衝、和車流妥協時，倫敦的空氣品質正在快速改善。<br/>根據英國《空氣品質標準法》，PM2.5 的年平均濃度不得超過10 微克／立方公尺，而二氧化氮（NO₂）的年平均濃度上限為40 微克／立方公尺 。</p>'
            ),
            id: 3,
            imgLink: null,
            imgPosition: "left",
            subtitle: null,
            title: null,
            imgInfo: sanitizer.bypassSecurityTrustHtml(
                '<span style="font-size: 12px; color: gray; float: left">(圖2) adobe stock</span>'
            ),
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: null,
            blockImgName: null,
            blockIndex: 8,
            blockName: "block9",
            blockType: 3,
            content: null,
            id: 5,
            imgLink: null,
            imgPosition: null,
            subtitle: sanitizer.bypassSecurityTrustHtml(
                '<p style="font-size: 20px; text-align: left; color: black; margin-top: 40px">國王學院原本預測倫敦需 193 年才能達成 NO₂ 的法定標準，但隨著超低排放區（ULEZ）政策的擴大實施，這個目標有望提前 185 年達成。'
            ),
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: null,
            blockImgName: null,
            blockIndex: 8,
            blockName: "block9",
            blockType: 3,
            content: null,
            id: 5,
            imgLink: null,
            imgPosition: null,
            subtitle: sanitizer.bypassSecurityTrustHtml(
                '<p style="font-size: 20px; text-align: left; color: black; margin-top: 40px">制度不是憑空設想，而是經過數據監測與政策實驗的逐步落實：<br/>從「一條收費線」到如今成為覆蓋整個城市的「治理網」，ULEZ 不只是環境條文，而是促使市民與城市生活逐步轉變的槓桿。<br/>它讓人重新思考：<br/></p>' +
                    '<p style="font-size: 20px; text-align: left; color: #2681bd; margin-top: 0px">我們願意為了更長遠的未來，忍受多大的短期不便？</p>' +
                    '<p style="font-size: 20px; text-align: left; color: black; margin-top: 0px">也許我們該重新想像，「永續」不是一句環保口號，而是一場社會集體信任的鍛鍊。<br/>我們是否能設計一種制度，讓「做對的選擇」變得更簡單？</p>'
            ),
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: "/assets/img/blog/倫敦空汙治理/3.jpeg",
            blockImgName: "NCour_NTUST_4.jpg",
            blockIndex: 4,
            blockName: "block5",
            blockType: 6,
            content: sanitizer.bypassSecurityTrustHtml(
                '<p style="color: #2681bd; font-size: 22px">制度的誕生，從衝突中激發的改變</p>' +
                    '<p style="font-size: 20px; color: black;">2019 年，倫敦正式啟動 ULEZ 制度，針對不符歐盟六期排放標準的汽車與機車課徵每日 £12.5 英鎊（約台幣 510 元）的進城費，違者由智慧監控攝影機自動開罰，看似簡單的政策，卻在上路之初掀起三場震撼的制度撞擊。</p>'
            ),
            id: 3,
            imgLink: null,
            imgPosition: "left",
            subtitle: null,
            title: null,
            imgInfo: sanitizer.bypassSecurityTrustHtml(
                '<span style="font-size: 12px; color: gray; float: left">(圖3) adobe stock</span>'
            ),
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: null,
            blockImgName: null,
            blockIndex: 1,
            blockName: "block2",
            blockType: 3,
            content: null,
            id: 2,
            imgLink: null,
            imgPosition: null,
            title: "【衝突一】社會階層不平衡 × 經濟弱勢群體反彈",
            subtitle: sanitizer.bypassSecurityTrustHtml(
                '<p style="font-size: 20px; text-align: left; color: black; margin: 0px">政策最先衝擊的不是企業或大型車隊，而是住在市郊、仰賴老車通勤的中下階層。他們抗議政策是「和窮人搶錢」，是對「弱勢開刀」的工具；批評「我們不是不想換車，是根本沒錢換。」2023 年政策擴大實施後，社會反彈進入爆炸期：<b>市區內掀起反 ULEZ行動潮，反對民眾不但上街抗議</b>，市長被貼上「騙子」標籤，攝影機接連遭破壞，超過 300 部設備被盜或毀損，這也成為英國政壇的<b>選戰破口</b>：工黨在 2023 年一場補選中敗北，選區候選人直指「ULEZ」成為敗選主因。</p>'
            ),
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: null,
            blockImgName: null,
            blockIndex: 1,
            blockName: "block2",
            blockType: 3,
            content: null,
            id: 2,
            imgLink: null,
            imgPosition: null,
            title: "【衝突二】制度成本過高 × 成效可信度爭議",
            subtitle: sanitizer.bypassSecurityTrustHtml(
                '<p style="font-size: 20px; text-align: left; color: black; margin: 0px">反對黨批評，空污改善並非 ULEZ 一力促成，<b>市政府過度渲染成效</b>。<br/>倫敦議會反對派議員更直言：「這個政策讓整個城市與市民承擔龐大債務，卻只換來一堆『可能、假設、推論』支撐的報告。」更有人指出，僅年減碳排 81.3 萬噸、2% 降幅，是否值得如此龐大的執行與社會成本？甚至有評論直言：「這是一筆靠推論與假設包裝出來的政治帳。」<br/><b>對支持者來說，這是長遠堅持的證明；對質疑者而言，則是高投入低回報</b>。</p>'
            ),
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: null,
            blockImgName: null,
            blockIndex: 1,
            blockName: "block2",
            blockType: 3,
            content: null,
            id: 2,
            imgLink: null,
            imgPosition: null,
            title: "【衝突三】生活秩序被打亂 × 社區結構遭衝擊",
            subtitle: sanitizer.bypassSecurityTrustHtml(
                '<p style="font-size: 20px; text-align: left; color: black; margin: 0px">反對聲浪最直接的來自「生活的瓦解感」：</p>' +
                    '<p style="font-size: 20px; text-align: left; color: black; margin-left: 20px">• 有人為了合規報廢愛車，卻無法負擔新車費用。</p>' +
                    '<p style="font-size: 20px; text-align: left; color: black; margin-left: 20px">• 有人因為不符新制而被迫更換工作地點。</p>' +
                    '<p style="font-size: 20px; text-align: left; color: black; margin-left: 20px">• 有人指出「ULEZ 摧毀了我們原有的照護網絡」，長輩看診、社區互助、家庭接送，都因不能開車進市區而中斷。</p>' +
                    '<p style="font-size: 20px; text-align: left; color: black; margin: 0px">甚至在 2023 年，五個倫敦地區（Bexley、Bromley、Harrow、Hillingdon 與 Surrey）<b>聯合提出法律訴訟</b>反對 ULEZ 擴張，雖然最終敗訴，卻凸顯這不是全民共識，而是一場制度與生活的拉扯。</p>'
            ),
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: null,
            blockImgName: null,
            blockIndex: 8,
            blockName: "block9",
            blockType: 3,
            content: null,
            id: 5,
            imgLink: null,
            imgPosition: null,
            subtitle: sanitizer.bypassSecurityTrustHtml(
                '<p style="font-size: 20px; text-align: left; color: black; margin-top: 30px">制度從來不是完美啟動，而是從反對聲中逐步修正、資訊透明的溝通，<b>以及強化社會共感的信任工程，ULEZ 的每一步推進，都證明了</b>：<b style="color: #2681bd">改革不是沒有風險，但更大的風險，是什麼都不做</b>。</p>'
            ),
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: null,
            blockImgName: null,
            blockIndex: 8,
            blockName: "block9",
            blockType: 3,
            content: null,
            id: 5,
            imgLink: null,
            imgPosition: null,
            subtitle: sanitizer.bypassSecurityTrustHtml(
                '<p style="font-size: 20px; text-align: left; color: black; margin-top: 30px">這也是我們 N-Cour 設計時的理念：<b>你無法在第一天解決所有反彈，但你可以設計一套可以持續修正、被理解的制度，讓願意理解的人成為前進的同盟</b>。</p>'
            ),
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: "/assets/img/blog/倫敦空汙治理/4.jpeg",
            blockImgName: "",
            blockIndex: 0,
            blockName: "block1",
            blockType: 8,
            content: null,
            id: 1,
            imgLink: null,
            imgPosition: null,
            subtitle: null,
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: null,
            blockImgName: null,
            blockIndex: 8,
            blockName: "block9",
            blockType: 3,
            content: null,
            id: 5,
            imgLink: null,
            imgPosition: null,
            subtitle: sanitizer.bypassSecurityTrustHtml(
                '<span style="font-size: 12px; color: gray; float: left;text-transform:lowercase;font-weight: normal">(圖4) adobe stock</span>'
            ),
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: null,
            blockImgName: null,
            blockIndex: 1,
            blockName: "block2",
            blockType: 3,
            content: null,
            id: 2,
            imgLink: null,
            imgPosition: null,
            title: "制度不是一次到位，而是持續調整的過程",
            subtitle: sanitizer.bypassSecurityTrustHtml(
                '<p style="font-size: 20px; text-align: left; color: black; margin: 0px">ULEZ 並不是一上路就擴及全市的「鐵腕政策」。從 2019 年起，倫敦選擇以「小區域、長緩衝、多階段」的方式逐步擴大制度規模。每次政策擴張，政府都預留半年以上預告期，並同步推出多項補助與過渡措施：</p>' +
                    '<p style="font-size: 20px; text-align: left; color: black; margin-left: 20px">• 對象明確的報廢補助：符合條件的車主可獲最高 £2,000（約新台幣 8 萬）的汰舊補助金。</p>' +
                    '<p style="font-size: 20px; text-align: left; color: black; margin-left: 20px">• 弱勢群體專案協助：身心障礙者、中小企業車主可申請延後執行、替代方案或額外資源。</p>' +
                    '<p style="font-size: 20px; text-align: left; color: black; margin-left: 20px">• 遷就現實，滾動式修法：根據空污監測數據、市民回饋與社會狀況，制度持續微調，如範圍擴大、車種認定調整等，讓政策有「轉彎空間」。即便如此，仍無法完全消弭反對聲浪，這恰好說明一件事：<b>好的政策，不等於沒有反對；但好的制度，值得被持續修正與堅持推動</b>。</p>' +
                    '<p style="font-size: 20px; text-align: left; color: black; margin: 0px">ULEZ 的政策並非死板執行，而是：</p>' +
                    '<p style="font-size: 20px; text-align: left; color: black; margin-left: 20px">• <b>滾動式設計</b>（根據數據調整政策適用與範圍）</p>' +
                    '<p style="font-size: 20px; text-align: left; color: black; margin-left: 20px">• <b>社會對話</b>（透過民意、選舉與媒體不斷碰撞辯證）</p>' +
                    '<p style="font-size: 20px; text-align: left; color: black; margin-left: 20px">• <b>轉型補助</b>（讓改變有台階可下、有緩衝可待）</p>' +
                    '<p style="font-size: 20px; text-align: left; color: black; margin-left: 0px">這些機制的存在，並非為了讓政策「討喜」，而是讓更多人能夠「有條件地參與轉型」，若能搭配補助、階段推進與資訊透明，就能讓反對聲變成回饋，讓「改變」不只是壓力，而是選擇。</p>'
            ),
            imgInfo: null,
        },
        // {
        //     backImg: null,
        //     backImgName: null,
        //     blockImg: "/assets/img/blog/倫敦空汙治理/4.jpeg",
        //     blockImgName: "4.jpeg",
        //     blockIndex: 4,
        //     blockName: "block5",
        //     blockType: 6,
        //     content: sanitizer.bypassSecurityTrustHtml(
        //         '<p style="color: #2681bd; font-size: 22px">制度不是一次到位，而是持續調整的過程</p>' +
        //             '<p style="font-size: 20px; color: black;">ULEZ 並不是一上路就擴及全市的「鐵腕政策」。從 2019 年起，倫敦選擇以「小區域、長緩衝、多階段」的方式逐步擴大制度規模。每次政策擴張，政府都預留半年以上預告期，並同步推出多項補助與過渡措施：<br/>• 對象明確的報廢補助：符合條件的車主可獲最高 £2,000（約新台幣 8 萬）的汰舊補助金。<br/>• 弱勢群體專案協助：身心障礙者、中小企業車主可申請延後執行、替代方案或額外資源。<br/>• 遷就現實，滾動式修法：根據空污監測數據、市民回饋與社會狀況，制度持續微調，如範圍擴大、車種認定調整等，讓政策有「轉彎空間」。即便如此，仍無法完全消弭反對聲浪，這恰好說明一件事：<b>好的政策，不等於沒有反對；但好的制度，值得被持續修正與堅持推動</b><br/>。ULEZ 的政策並非死板執行，而是：<br/>• <b>滾動式設計</b>（根據數據調整政策適用與範圍）<br/>• <b>社會對話</b>（透過民意、選舉與媒體不斷碰撞辯證）<br/>• <b>轉型補助</b>（讓改變有台階可下、有緩衝可待）<br/>這些機制的存在，並非為了讓政策「討喜」，而是讓更多人能夠「有條件地參與轉型」，若能搭配補助、階段推進與資訊透明，就能讓反對聲變成回饋，讓「改變」不只是壓力，而是選擇。</p>'
        //     ),
        //     id: 3,
        //     imgLink: null,
        //     imgPosition: "left",
        //     subtitle: null,
        //     title: null,
        //     imgInfo: sanitizer.bypassSecurityTrustHtml(
        //         '<span style="font-size: 16px"></span>'
        //     ),
        // },
        {
            backImg: null,
            backImgName: null,
            blockImg: null,
            blockImgName: null,
            blockIndex: 1,
            blockName: "block2",
            blockType: 3,
            content: null,
            id: 2,
            imgLink: null,
            imgPosition: null,
            title: "成效與擴散：反彈之後，是數據與連鎖反應",
            subtitle: sanitizer.bypassSecurityTrustHtml(
                '<p style="font-size: 20px; text-align: left; color: black; margin: 0px">即便歷經激烈爭議與選戰衝擊，ULEZ 用數據證明了「制度堅持」的價值。<br/>根據《The Guardian》與倫敦市議會報告，自 2019 年實施以來：</p>' +
                    '<p style="font-size: 20px; text-align: left; color: black; margin-left: 20px">• 二氧化氮（NO₂）：全市濃度下降了 27%</p>' +
                    '<p style="font-size: 20px; text-align: left; color: black; margin-left: 20px">• 細懸浮微粒（PM2.5）：外倫敦地區的車輛排放量比未實施 ULEZ 預估值低 31%</p>' +
                    '<p style="font-size: 20px; text-align: left; color: black; margin-left: 20px">• 二氧化碳（CO₂）：2019 至 2024 年間，交通運輸部門的 CO₂ 排放量減少了約 36%，相當於 3400 噸</p>' +
                    '<p style="font-size: 20px; text-align: left; color: black; margin-left: 20px">• 空氣品質改善：外倫敦地區的空氣品質改善速度超過英格蘭其他地區，首次與全國平均水平持平</p>' +
                    '<p style="font-size: 20px; text-align: left; color: black; margin-left: 0px">這些成果不僅提升了環境品質，也帶來了健康與經濟效益。例如，布拉德福德市在實施清潔空氣區政策一年內，NHS（國民健康服務）每月因呼吸道疾病的支出減少超過 3 萬英鎊（約 118 萬台幣） 。</p>'
            ),
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: null,
            blockImgName: null,
            blockIndex: 8,
            blockName: "block9",
            blockType: 3,
            content: null,
            id: 5,
            imgLink: null,
            imgPosition: null,
            subtitle: sanitizer.bypassSecurityTrustHtml(
                '<p style="font-size: 20px; text-align: left; color: black; margin-top: 30px">這樣的轉變，成為歐洲城市治理的催化劑，<b>從倫敦出發，串起歐洲低排放區（LEZ）網絡</b>。<br/>根據 Clean Cities Campaign 報告，截至 2022 年，歐洲已有 <b>320 個城市</b>推動 LEZ，預計2025 年將成長至 <b>507 個城市</b>，增幅達 <b>58%</b>，正逐步描繪出一張綠色治理的地圖：</p>' +
                    '<p style="font-size: 20px; text-align: left; color: black; margin-left: 20px">• <b>巴黎</b>：2024 年 11 月起於市中心實施「限制通行區（LTZ）」，禁止無正當理由的機動車進入，以降低噪音與空污。</p>' +
                    '<p style="font-size: 20px; text-align: left; color: black; margin-left: 20px">• <b>阿姆斯特丹</b>：規劃 2030 年全面禁行燃油車。</p>' +
                    '<p style="font-size: 20px; text-align: left; color: black; margin-left: 20px">• <b>米蘭</b>：「Area B」涵蓋約 70% 市區，限制高污染車輛進入。</p>' +
                    '<p style="font-size: 20px; text-align: left; color: black; margin-left: 20px">• <b>布魯塞爾、柏林、奧斯陸</b>：推進智慧監控與資料治理，串聯交通、碳排與公共健康數據。</p>'
            ),
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: null,
            blockImgName: null,
            blockIndex: 8,
            blockName: "block9",
            blockType: 3,
            content: null,
            id: 5,
            imgLink: null,
            imgPosition: null,
            subtitle: sanitizer.bypassSecurityTrustHtml(
                '<p style="font-size: 20px; text-align: left; color: black; margin-top: 30px"><b>不同城市有不同進程，但都指向同一件事：污染不是「忍耐的代價」，而是制度可以處理的問題</b>。<br/>制度讓空氣不只是「達標」，更讓城市進入一種「可治理」的狀態：</p>' +
                    '<p style="font-size: 20px; text-align: left; color: #2681bd; margin-left: 20px">◼ 從被動監測，變成主動控管</p>' +
                    '<p style="font-size: 20px; text-align: left; color: #2681bd; margin-left: 20px">◼ 從風險預測，轉為效益治理</p>' +
                    '<p style="font-size: 20px; text-align: left; color: #2681bd; margin-left: 20px">◼ 從單點排放處理，邁向區域共治思維</p>' +
                    '<p style="font-size: 20px; text-align: left; color: #2681bd; margin-left: 20px">◼ 從減排數據，連動到健康經濟共享</p>' +
                    '<p style="font-size: 20px; text-align: left; color: black; margin-top: 0px">這些數據與實例證明，當政策進入執行軌道，從街頭空氣到城市邏輯、從交通工具控管，到醫療與環境的正向回饋，改變是可以發生的，制度不只是框架，而是一種能夠滾動前進的信任架構。</p>'
            ),
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: null,
            blockImgName: null,
            blockIndex: 1,
            blockName: "block2",
            blockType: 3,
            content: null,
            id: 2,
            imgLink: null,
            imgPosition: null,
            title: "從規範執行到治理升級",
            subtitle: sanitizer.bypassSecurityTrustHtml(
                '<p style="font-size: 20px; text-align: left; color: black; margin: 0px">當我們討論「減碳」、「淨零」或「空污治理」，多數人的焦點常放在個人責任或企業設備升級，例如：少開車、企業要汰舊換新，卻很少談到制度本身的設計。但倫敦的 ULEZ 告訴我們正是「制度作為」在氣候治理中的具體展現。這項政策不只是單一措施，而是一套涵蓋「交通管制、空污稽核、數據監控、政策配套」的系統性治理工程，讓一個城市用制度為轉型開路。它展示了幾個關鍵意義：</p>' +
                    '<p style="font-size: 20px; text-align: left; color:  #2681bd; margin-left: 20px">• 改變需要時間，而制度能讓好事變成常態：</p>' +
                    '<p style="font-size: 20px; text-align: left; color:  black; margin-left: 20px">ULEZ 從限制高污染車輛進入開始，進一步導引市民改變購車、通勤選擇，連帶推升電動車市佔、公共運輸使用率與共享交通的接受度。它不是靠大家自律，而是創造一個讓改變「更容易」的制度場域。</p>' +
                    '<p style="font-size: 20px; text-align: left; color:  #2681bd; margin-left: 20px">• 從即期效果到長期規劃的治理升級：</p>' +
                    '<p style="font-size: 20px; text-align: left; color:  black; margin-left: 20px">短期內，政策讓空污明顯下降；中長期，則轉化成都市交通規劃、產業轉型與健康照護支出的節省。這種轉化，讓「環境政策」不再是單點式宣示，而是跨領域的長期工程。</p>' +
                    '<p style="font-size: 20px; text-align: left; color: black; margin-top: 10px">制度就是規則與邏輯的集成，是改變的基礎設計，就像 N-Cour 永續淨零平台，讓碳管理制度落地的重要工具，它不只計算碳排，更協助企業建立流程、權責配置與確保數據可靠性，這與 ULEZ 的精神不謀而合，從政策到工具，從理念到實踐。</p>'
            ),
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: null,
            blockImgName: null,
            blockIndex: 1,
            blockName: "block2",
            blockType: 3,
            content: null,
            id: 2,
            imgLink: null,
            imgPosition: null,
            title: "從倫敦，看見制度設計的力量",
            subtitle: sanitizer.bypassSecurityTrustHtml(
                '<p style="font-size: 20px; text-align: left; color: black; margin: 0px">ULEZ 的成功，除了靠民眾的自律遵守，透過制度設計，重新定義「<b style="color: #2681bd">什麼是預設的行動</b>」。當違規成本實際存在、當乾淨空氣變成可以計算的健康收益，轉型就不再只是呼籲良心的倡議，而是一套可以運作的治理機制。</p>'
            ),
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: null,
            blockImgName: null,
            blockIndex: 8,
            blockName: "block9",
            blockType: 3,
            content: null,
            id: 5,
            imgLink: null,
            imgPosition: null,
            subtitle: sanitizer.bypassSecurityTrustHtml(
                '<p style="font-size: 20px; text-align: left; color: black; margin-top: 30px">這也提醒我們：永續不該僅是壓力式的責任，而是設計過的流程與配套。<br/>倫敦透過「區域收費 × 監測系統 × 汽機車汰舊補助 × 資料公開」等手段，讓 ULEZ 從政策口號走向實質執行，也讓空氣治理從願景變成具體制度。<br/>這些制度的背後，包含了責任邏輯、角色劃分與流程設計，正呼應我們在 N-Cour 強調的四大治理支柱：</p>'
                // '<p style="font-size: 20px; text-align: left; color:  black; margin-left: 20px">• <b>人</b>：誰會受影響、誰是關鍵參與者？</p>' +
                // '<p style="font-size: 20px; text-align: left; color:  black; margin-left: 20px">• <b>流程</b>：從檢核到減量，有清楚邏輯與節奏嗎？</p>' +
                // '<p style="font-size: 20px; text-align: left; color:  black; margin-left: 20px">• <b>權責</b>：組織內部的角色分工與外部協作是否明確？</p>' +
                // '<p style="font-size: 20px; text-align: left; color:  black; margin-left: 20px">• <b>制度</b>：是否有可持續監測與滾動修正的設計？</p>' +
                // '<p style="font-size: 20px; text-align: left; color:  black; margin-left: 0px">這是我們產品的主要核心，也希望能成為每一個企業或城市，邁向淨零的引擎。</p>'
            ),
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: "/assets/img/blog/倫敦空汙治理/N-Cour-Core.jpg",
            blockImgName: "NCour_NTUST_4.jpg",
            blockIndex: 4,
            blockName: "block5",
            blockType: 6,
            content: sanitizer.bypassSecurityTrustHtml(
                '<p style="font-size: 20px; text-align: left; color:  black; margin-left: 0px;text-wrap: nowrap;">• <b>人</b>：誰會受影響、誰是關鍵參與者？</p>' +
                    '<p style="font-size: 20px; text-align: left; color:  black; margin-left: 0px;text-wrap: nowrap;">• <b>流程</b>：從檢核到減量，有清楚邏輯與節奏嗎？</p>' +
                    '<p style="font-size: 20px; text-align: left; color:  black; margin-left: 0px;text-wrap: nowrap;">• <b>權責</b>：組織內部的角色分工與外部協作是否明確？</p>' +
                    '<p style="font-size: 20px; text-align: left; color:  black; margin-left: 0px;text-wrap: nowrap;">• <b>制度</b>：是否有可持續監測與滾動修正的設計？</p>'
            ),
            id: 3,
            imgLink: null,
            imgPosition: "left",
            subtitle: null,
            title: null,
            imgInfo: sanitizer.bypassSecurityTrustHtml(
                '<span style="font-size: 12px; color: gray; float: left">(圖 5) N-Cour 四核心/碩達系統</span>'
            ),
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: null,
            blockImgName: null,
            blockIndex: 1,
            blockName: "block2",
            blockType: 3,
            content: null,
            id: 2,
            imgLink: null,
            imgPosition: null,
            title: "道在足下，行在當下",
            subtitle: sanitizer.bypassSecurityTrustHtml(
                '<p style="font-size: 20px; text-align: left; color: black; margin: 0px">回望倫敦，是為了看見可能，不是複製一模一樣的道路。<br/>當台灣政策還在路上，企業其實可以先行。</p>'
            ),
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: null,
            blockImgName: null,
            blockIndex: 8,
            blockName: "block9",
            blockType: 3,
            content: null,
            id: 5,
            imgLink: null,
            imgPosition: null,
            subtitle: sanitizer.bypassSecurityTrustHtml(
                '<p style="font-size: 20px; text-align: left; color: black; margin-top: 30px">在永續這條路上，企業除了應對 ESG 評鑑，更有機會成為<b>推動改變的節點</b>：</p>' +
                    '<p style="font-size: 20px; text-align: left; color:  black; margin-left: 20px">• 從<b>能源使用、製程盤查、設備替換</b>等範疇一二著手，提升基礎減排治理能力</p>' +
                    '<p style="font-size: 20px; text-align: left; color:  black; margin-left: 20px">• 進一步盤點<b>供應鏈上下游資訊</b>，為未來的範疇三透明化做準備</p>' +
                    '<p style="font-size: 20px; text-align: left; color:  black; margin-left: 20px">• 重新思考<b>物流、採購、合作廠商的碳足跡影響</b>，找出關鍵減排環節</p>' +
                    '<p style="font-size: 20px; text-align: left; color:  black; margin-left: 0px">更可以導入 <b>N-Cour</b> 永續淨零平台，建立屬於企業的「低排放治理制度」：</p>' +
                    '<p style="font-size: 20px; text-align: left; color:  black; margin-left: 20px"><b>• 幫你梳理碳排背後的流程與結構</p>' +
                    '<p style="font-size: 20px; text-align: left; color:  black; margin-left: 20px">• 幫你建立權責分工的治理制度</p>' +
                    '<p style="font-size: 20px; text-align: left; color:  black; margin-left: 20px">• 用數據陪你走完減碳每一步</b></p>'
            ),
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: "/assets/img/blog/倫敦空汙治理/N-Cour.jpg",
            blockImgName: "",
            blockIndex: 0,
            blockName: "block1",
            blockType: 8,
            content: null,
            id: 1,
            imgLink: null,
            imgPosition: null,
            subtitle: null,
            title: null,
            imgInfo: sanitizer.bypassSecurityTrustHtml(
                '<span style="font-size: 16px"></span>'
            ),
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: null,
            blockImgName: null,
            blockIndex: 8,
            blockName: "block9",
            blockType: 3,
            content: null,
            id: 5,
            imgLink: null,
            imgPosition: null,
            subtitle: sanitizer.bypassSecurityTrustHtml(
                '<span style="font-size: 12px; color: gray; float: left;text-transform:inherit;font-weight: normal">(圖6) N-Cour 平台數據呈現/碩達系統</span>'
            ),
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: null,
            blockImgName: null,
            blockIndex: 8,
            blockName: "block9",
            blockType: 3,
            content: null,
            id: 5,
            imgLink: null,
            imgPosition: null,
            subtitle: sanitizer.bypassSecurityTrustHtml(
                '<p style="font-size: 20px; text-align: left; color: black; margin-top: 30px; font-weight: bold">空氣無象，萬物卻能感知；制度無形，卻能深刻改變世界，正如老子所言：道隱無名，然其運行不息。</p>' +
                    '<p style="font-size: 20px; text-align: left; color: black;">當政策能引導方向、當數據成為憑據、當企業與民眾都有參與的空間，永續就不再只是理想，而是能夠實踐、能夠衡量的進展。全球都在加快低排放治理的腳步，企業不必一開始就走得快，但要選對方向，建好基礎。</p>' +
                    '<p style="font-size: 20px; text-align: left; color: black; margin-top: 30px">我們不是因為做得到才開始，而是因為開始了，才慢慢做得到。</p>' +
                    '<p style="font-size: 20px; text-align: left; color: black; margin-top: 0px">這是我們起步的時刻，希望能邀請更多夥伴一起走向永續的開始。</p>'
            ),
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: null,
            blockImgName: null,
            blockIndex: 8,
            blockName: "block12",
            blockType: 3,
            content: null,
            id: 5,
            imgLink: null,
            imgPosition: null,
            subtitle: sanitizer.bypassSecurityTrustHtml(
                '<p style="font-size: 14px; text-align: left; color: black;">參考資料：</p>' +
                    '<p style="font-size: 14px; text-align: left; color: black; font-weight: bold">1. Cleaner air for Londoners after Ulez – report</p>' +
                    '<p style="font-size: 14px; text-align: left; color: black;"><a href="https://www.bbc.com/news/articles/cgq9nnj274xo" target="_blank" style="display: inline; word-break: break-all;">https://www.bbc.com/news/articles/cgq9nnj274xo</a></p>' +
                    '<p style="font-size: 14px; text-align: left; color: black; font-weight: bold">2. Ulez expansion: Contested claims examined</p>' +
                    '<p style="font-size: 14px; text-align: left; color: black;"><a href="https://www.bbc.com/news/uk-england-london-64798395" target="_blank" style="display: inline; word-break: break-all;">https://www.bbc.com/news/uk-england-london-64798395</a></p>' +
                    '<p style="font-size: 14px; text-align: left; color: black; font-weight: bold">3. Dramatic fall in London’s levels of deadly pollutants after Ulez expansion</p>' +
                    '<p style="font-size: 14px; text-align: left; color: black;"><a href="https://www.theguardian.com/environment/2025/mar/07/london-air-pollution-down-since-ulez-expansion-study" target="_blank" style="display: inline; word-break: break-all;">https://www.theguardian.com/environment/2025/mar/07/london-air-pollution-down-since-ulez-expansion-study</a></p>' +
                    '<p style="font-size: 14px; text-align: left; color: black; font-weight: bold">4. Ultra Low Emission Zone</p>' +
                    '<p style="font-size: 14px; text-align: left; color: black;"><a href="https://tfl.gov.uk/modes/driving/ultra-low-emission-zone" target="_blank" style="display: inline; word-break: break-all;">https://tfl.gov.uk/modes/driving/ultra-low-emission-zone</a></p>' +
                    '<p style="font-size: 14px; text-align: left; color: black; font-weight: bold">5. The Ultra Low Emission Zone (ULEZ) for London</p>' +
                    '<p style="font-size: 14px; text-align: left; color: black;"><a href="https://www.london.gov.uk/programmes-strategies/environment-and-climate-change/pollution-and-air-quality/ultra-low-emission-zone-ulez-london" target="_blank" style="display: inline; word-break: break-all;">https://www.london.gov.uk/programmes-strategies/environment-and-climate-change/pollution-and-air-quality/ultra-low-emission-zone-ulez-london</a></p>' +
                    '<p style="font-size: 14px; text-align: left; color: black; font-weight: bold">6. Low emission zones are transforming cities in spring 2025 (I measured the surprising impact on drivers)</p>' +
                    '<p style="font-size: 14px; text-align: left; color: black;"><a href="https://www.journee-mondiale.com/en/low-emission-zones-are-transforming-cities-in-spring-2025-i-measured-the-surprising-impact-on-drivers/" target="_blank" style="display: inline; word-break: break-all;">https://www.journee-mondiale.com/en/low-emission-zones-are-transforming-cities-in-spring-2025-i-measured-the-surprising-impact-on-drivers/</a></p>'
            ),
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: "",
            blockImgName: "",
            blockIndex: 0,
            blockName: "block14",
            blockType: 8,
            content: null,
            id: 1,
            imgLink: null,
            imgPosition: null,
            subtitle: null,
            title: null,
            imgInfo: null,
        },
    ];
}
